// utils/.js

// Utility function to get the CSRF token from cookies
export const getCsrfTokenFromCookies = () => {
    const csrfCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('csrf_token='));
  
    // If the cookie is found, split and return the value (CSRF token)
    if (csrfCookie) {
      return csrfCookie.split('=')[1];  // Returns the token value
    }
    return null;  // Return null if no CSRF token is found
  };
  
  export const setCsrfTokenToCookies = (token) => {
    document.cookie = `csrf_token=${token}; path=/; Secure; SameSite=Strict`;
  };